import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggleOpen, toggleClose,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
})=>{

    const openModal = (_, title, compont, dataRequest) => {
        toggleOpen(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggleClose()
    }

    const handleClickShowModal = async (event) => {
        
        const { fetchAInfoEvent } = FetchData
        const infoEvent = event._def

        // console.log('[useActions][handleClickShowModal] event ', event);
        console.log('[useActions][handleClickShowModal] infoEvent ', infoEvent);

        fetchAInfoEvent.setParamsToSearch({
            idagenda: infoEvent.publicId,
        })
        fetchAInfoEvent.executeFetch()

        openModal("", "", "event-form", {})
    }

    const handleClickReturnModal = async () => {
        
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen
        onResetForm()
        closeModal()
    }
    
    const handleCustomButtonClick = async () => {
        
        const { calendarRef } = globalStates
        const { getPreviousMonthDate, getNextMonthDate } = Helpers
        const { fetchAllEvents } =  FetchData
        
        const formatter = new Intl.DateTimeFormat('en-CA');
        const formattedCalendarDate = formatter.format(calendarRef.current.getApi().getDate());
        const fecha_inicio = getPreviousMonthDate(formattedCalendarDate)
        const fecha_final = getNextMonthDate(formattedCalendarDate)

        fetchAllEvents.setParamsToSearch({
            fecha_acutal: formattedCalendarDate,
            fecha_inicio: fecha_inicio,
            fecha_final: fecha_final
        })
        fetchAllEvents.executeFetch()
    
    }

    const handleClickDeleteEvent = async () => {

        const { fetchAllEvents } =  FetchData
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

    
        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/agenda-abogacia/delete-agenda-abogacia/${formState.idagenda}`)
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        onResetForm()
                        fetchAllEvents.executeFetch()
                        handleClickReturnModal()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
        
    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchAllEvents } =  FetchData
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const _dataBody = {
            idagenda: formState.idagenda,
            tipo_evento: formState.tipo_evento,
            fecha_evento: formState.fecha_evento,
            descripcion: formState.descripcion,
            user: user.username
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        await marvarApi.post( `/agenda-abogacia/create-agenda-abogacia`, _dataBody )
            .then(({ data }) => {
                
                alertMessage(data)
                onResetForm()
                fetchAllEvents.executeFetch()
                handleClickReturnModal()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }
    
    return Object.freeze({
        openModal,
        handleCustomButtonClick,

        handleClickShowModal,
        handleClickReturnModal,
        handleClickDeleteEvent,
        onSubmitForm
    })

}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}